import React, { useState, useEffect, FormEvent } from 'react';
import { motion } from 'framer-motion';
import { Search, X } from 'lucide-react';

type Props = {
  query: string;
  onQueryCommit: (q: string) => void;
  debounceMs?: number;
};

const NotesSearchHero: React.FC<Props> = ({ query, onQueryCommit, debounceMs = 300 }) => {
  const [input, setInput] = useState(query);

  useEffect(() => {
    setInput(query);
  }, [query]);

  useEffect(() => {
    const t = window.setTimeout(() => {
      if (input.trim() !== query.trim()) {
        onQueryCommit(input.trim());
      }
    }, debounceMs);
    return () => window.clearTimeout(t);
  }, [input, query, onQueryCommit, debounceMs]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onQueryCommit(input.trim());
  };

  const clear = () => {
    setInput('');
    onQueryCommit('');
  };

  return (
    <div className="notes-search-hero glow-card">
      <form className="notes-search-hero__form" onSubmit={handleSubmit}>
        <Search size={22} color="var(--accent-primary)" aria-hidden />
        <input
          type="search"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Not ara: calculus, anayasa, biyokimya, ODTÜ…"
          aria-label="Notlarda ara"
          autoComplete="off"
        />
        {input ? (
          <button type="button" className="notes-search-hero__clear" onClick={clear} aria-label="Aramayı temizle">
            <X size={18} />
          </button>
        ) : null}
        <motion.button
          type="submit"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="btn-shimmer notes-search-hero__submit"
        >
          Ara
        </motion.button>
      </form>
      <p className="notes-search-hero__hint">
        Başlık, açıklama, bölüm, üniversite ve dosya adında arar · çok kelimeli arama desteklenir
      </p>
    </div>
  );
};

export default NotesSearchHero;
